import styled, { css } from 'styled-components';
import { Wrapper as FormButton } from 'components/Button/style';
import { Row as GridRow } from 'components/GridSystem';

type CodeType = {
  hasCode: boolean;
};

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    border-top: 1px solid ${theme.colors.neutral300};
    width: 100%;
    display: flex;
    justify-content: center;
    border-radius: 8px 8px 0 0;
    padding: 28px 0;
  `}

  ${FormButton} {
    margin-bottom: 8px;

    @media (max-width: 576px) {
      margin-bottom: 0;
    }
  }
`;

export const Row = styled(GridRow)`
  justify-content: space-between;
`;

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  min-width: 25%;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const ShowDesktop = styled.div`
  @media (max-width: 576px) {
    display: none;
  }
  @media (min-width: 577px) {
    display: block;
  }
`;

const DetailsModifiers = {
  withCode: () => css`
    justify-content: space-between;
  `,
  withoutCode: () => css`
    justify-content: flex-start;
  `,
};

export const Details = styled.div<CodeType>`
  ${({ hasCode }) => css`
    display: flex;
    width: 100%;
    align-items: center;
    ${hasCode && DetailsModifiers.withCode()}
    ${!hasCode && DetailsModifiers.withoutCode()}
  `}
`;

export const Code = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark60};
    font-size: 1.2rem;
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.statusSuccess40};
    font-weight: 700;
  `}
`;

export const PaymentOption = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver70};
    font-weight: 600;
    font-size: 1.2rem;

    display: flex;
    align-items: center;

    gap: 8px;
  `}
`;
